<template>
  <div>
    <el-form label-width="80px">
      <el-form-item>
        <div slot="label">
          <img v-if="user.PictureUri" :src="user.PictureUri" alt="" class="picture-icon">
        </div>
        <el-input type="textarea" placeholder="add a testimonial..." v-model="testimonial"></el-input>
      </el-form-item>
    </el-form>
    <el-button size="small" type="primary" @click="onAddTestimonial">Add</el-button>
    <el-button size="small" @click="$emit('cancel')">Cancel</el-button>
  </div>
</template>

<script>
import { HTTP } from '@/http-common'
import { TESTIMONIAL_SUBMIT_SUCCESS } from '@/assets/data/messages'

export default {
  props: ['user', 'recipe'],
  data() {
    return {
      testimonial: ''
    }
  },
  methods: {
    onAddTestimonial() {
      const testimonial = {
        AuthorId: this.user.Id,
        RecipeId: this.recipe.Id,
        Testimonial: this.testimonial,
        Rating: 0
      }
      HTTP.post('recipes/testimonials', testimonial).then(() => {
        this.$store.commit('SET_MESSAGE', TESTIMONIAL_SUBMIT_SUCCESS)
      })
    }
  }
}
</script>

<style>
</style>
